import React, { ChangeEvent, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import apiRest from '../../../services/apiRest'
import { StoreState } from '../../../store'
import { rename } from '../../../utils'
import * as XLSX from 'xlsx'

// material-ui
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'

// types
interface Props {
  categories: any[]
  openModalExcel: any
  setOpenModalExcel: any
}

type PropsEvent = ChangeEvent<{ value: unknown }>
type PropsPrintType = 'Extrato' | 'Relatório'

export const ResumeExcel = ({
  categories,
  openModalExcel,
  setOpenModalExcel,
}: Props) => {
  const { filters } = useSelector(({ transactionsState }: StoreState) => ({
    filters: transactionsState.filters,
  }))
  const [category, setCategory] = React.useState([
    {
      value: '',
      name: '',
    },
  ])

  const [state, setState] = useState({
    dateFrom: filters.dateFrom,
    dateTo: filters.dateTo,
    type: filters.type,
    resource: filters.resource,
    category: filters.category,
  })

  const [loading, setLoading] = useState(false)

  const churchId = useSelector(({ sessionState }: StoreState) => {
    return sessionState.user?.churches[sessionState.selectedChurchIndex]?.id
  })

  useEffect(() => {
    setState(filters)
  }, [filters])

  const onChangeFilterState = (key: string) => (event: PropsEvent) => {
    let content = event.target.value

    if (key === 'type') {
      let categoryValue = categories
        .filter((item) => item.active && item.type === content)
        .map((item) => ({ name: item.name, value: item.id }))

      setCategory(categoryValue)
      setState({ ...state, category: 'all', [key]: content as string })
    } else {
      setState({ ...state, [key]: content })
    }
  }

  const onClickExcel = async () => {
    setLoading(true)
    setOpenModalExcel(true)

    const popup = window.open('', '_blank')
    if (popup) {
      popup.document.write('Aguarde...')

      try {
        const { data } = await apiRest.get('/transactions/excel', {
          params: {
            churchId,
            dateFrom: state.dateFrom,
            dateTo: state.dateTo,
            type: state.type,
            category: state.category,
          },
        })

        // renomear propriedades de um objeto
        // rename(obj, prop, newName)
        rename(data, 'date', 'Data')
        rename(data, 'value', 'Valor')
        rename(data, 'categoryName', 'Categoria')
        rename(data, 'personName', 'Pessoa')
        rename(data, 'historic', 'Histórico')

        // criar um arquivo excel
        const worksheet = XLSX.utils.json_to_sheet(data)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'resumo')
        XLSX.writeFile(workbook, 'resumo.xlsx')
      } catch (err) {
        // console.log(err);
      } finally {
        setTimeout(() => {
          setLoading(false)
          popup.close()
        }, 3000)
      }
    }
  }

  return (
    <>
      <Dialog
        onClose={() => {
          setOpenModalExcel(false)
          setTimeout(() => {
            setState({
              dateFrom: filters.dateFrom,
              dateTo: filters.dateTo,
              type: filters.type,
              resource: filters.resource,
              category: filters.category,
            })
          }, 200)
        }}
        open={openModalExcel}
      >
        <DialogTitle>Exportar relatório para excel</DialogTitle>

        {loading ? (
          <DialogContent>
            <div className="flex flex-col items-center justify-center w-full h-full  ">
              <button
                style={{ color: '#1976D2' }}
                className="w-5/6 py-2 mt-2 font-semibold   text-center uppercase bg-white rounded"
              >
                Aguarde...
              </button>
            </div>
          </DialogContent>
        ) : (
          <>
            <DialogContent>
              <TextField
                type="date"
                label="Data inicial"
                value={state.dateFrom}
                onChange={onChangeFilterState('dateFrom')}
              />
              <TextField
                type="date"
                label="Data final"
                value={state.dateTo}
                onChange={onChangeFilterState('dateTo')}
              />
              {state.type === 'incomes' || state.type === 'expenses' ? (
                <FormControl
                  component="fieldset"
                  style={{ marginTop: 16, marginLeft: 25 }}
                >
                  <Select
                    value={state.category}
                    onChange={onChangeFilterState('category')}
                    placeholder="Name"
                    displayEmpty
                  >
                    <MenuItem disabled value={'all'}>
                      Selecione categoria
                    </MenuItem>
                    {category.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : null}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  marginTop: 16,
                }}
              >
                <FormControl component="fieldset" style={{ marginTop: 16 }}>
                  <FormLabel component="legend">Tipo</FormLabel>
                  <RadioGroup
                    row
                    value={state.type}
                    onChange={onChangeFilterState('type')}
                  >
                    <FormControlLabel
                      value="incomes"
                      control={<Radio color="primary" />}
                      label="Receitas"
                    />
                    <FormControlLabel
                      value="expenses"
                      control={<Radio color="primary" />}
                      label="Despesas"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </DialogContent>

            <DialogActions>
              <Button
                onClick={() => {
                  setOpenModalExcel(false)
                  setTimeout(() => {
                    setState({
                      dateFrom: filters.dateFrom,
                      dateTo: filters.dateTo,
                      type: filters.type,
                      resource: filters.resource,
                      category: filters.category,
                    })
                  }, 200)
                }}
              >
                Cancelar
              </Button>
              <Button onClick={onClickExcel} color="primary">
                Gerar
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  )
}
